import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setInviteFriendsStatus,
  setShowCashierPopup,
} from "redux-thunk/redux/slices/settings.slice";
import CashierReferrals from "./components/Referrals/index";
import CommonPopup from "components/ui-kit/CommonPopup/index";
import NavScrollWrapper from "components/ui-kit/NavScrollWrapper";
import CryptoDeposit from "./components/Crypto/CryptoDeposit/index";
import CryptoWithdraw from "./components/Crypto/CryptoWithdraw/index";

const TABS = [
  { id: "deposit", label: "Crypto Deposit" },
  { id: "withdraw", label: "Crypto Withdraw" },
  { id: "referrals", label: "Referrals" },
];

const CashierPopup = () => {
  const dispatch = useDispatch();
  const { inviteFriendsStatus } = useSelector((state) => state.settings);
  const { user } = useSelector((state) => state.user);

  const primaryWallet = user?.wallets?.find((w) => w.primary);
  const isCAD = primaryWallet?.currency?.code?.toLowerCase() === "cad";

  const [activeTab, setActiveTab] = useState("deposit");

  // If opened via referral invite, jump to referrals tab
  useEffect(() => {
    if (inviteFriendsStatus) setActiveTab("referrals");
  }, [inviteFriendsStatus]);

  useEffect(() => {
    return () => {
      if (inviteFriendsStatus) dispatch(setInviteFriendsStatus(false));
    };
  }, [dispatch, inviteFriendsStatus]);

  const handleTabClick = (id) => setActiveTab(id);

  return (
    <CommonPopup
      classes="cashier-modal"
      modalCloseHandler={() => dispatch(setShowCashierPopup(false))}
      id="cashierModal"
    >
      {/* Tab navigation — uses existing .custom-tabs-nav + .nav-link styles */}
      <div className="custom-tabs-nav">
        <NavScrollWrapper>
          {TABS.map((tab) => (
            <li key={tab.id} className="nav-item" role="presentation">
              <button
                className={`nav-link text-uppercase ${activeTab === tab.id ? "active" : ""}`}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                onClick={() => handleTabClick(tab.id)}
              >
                {tab.label}
              </button>
            </li>
          ))}
        </NavScrollWrapper>
      </div>

      {/* Tab content — React-controlled, no Bootstrap JS tab-pane system */}
      <div className="cashier-tab-body">
        {activeTab === "deposit" && <CryptoDeposit isCAD={isCAD} />}
        {activeTab === "withdraw" && <CryptoWithdraw />}
        {activeTab === "referrals" && <CashierReferrals />}
      </div>
    </CommonPopup>
  );
};

export default CashierPopup;
